import React from 'react';
import { ContentfulHeading } from '../contentfulHeading';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { PropositionCard, PropositionCardProps } from '../propositionCard';
import { BannerImage } from '../bannerImage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacings[4.5].px};
  margin: 0 auto;
  padding-top: ${theme.spacings[6].rem};
`;

const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: normal;
  gap: ${theme.spacings[5].px};
  ${breakpoint('lg')`
    flex-wrap:nowrap;
`}
`;

export type PropositionContainerProps = {
  bannerImage: {
    smImg: { url: string };
    mdImg: { url: string };
    lgImg: { url: string };
    href: string;
    openInNewTab: boolean;
    altText: string;
  };
  heading: {
    heading: string | number;
    subHeading: string | number;
  };
  cardPanelsCollection: {
    items: {
      iconImage: string;
      heading: string;
      subHeading: string;
    }[];
  };
};
export const PropositionContainer: React.FC<PropositionContainerProps> = ({
  bannerImage,
  cardPanelsCollection,
  heading,
}: PropositionContainerProps): JSX.Element => {
  const cardData: PropositionCardProps[] = cardPanelsCollection?.items
    ?.filter((v) => v !== null)
    .map((data) => ({
      iconImage: data?.iconImage,
      heading: data?.heading,
      subHeading: data?.subHeading,
    }));

  return (
    <Wrapper>
      <BannerImage
        href={bannerImage?.href}
        openInNewTab={bannerImage?.openInNewTab}
        urlLg={bannerImage?.lgImg?.url}
        urlMd={bannerImage?.mdImg?.url}
        urlSm={bannerImage?.smImg?.url}
        altText={bannerImage?.altText}
        hasBorderRadius
      />
      {cardData && (
        <ContentWrapper>
          <ContentfulHeading
            heading={heading?.heading}
            subHeading={heading?.subHeading}
          />
          <CardWrapper>
            {cardData.map((item: PropositionCardProps) => (
              <PropositionCard
                iconImage={item.iconImage}
                heading={item.heading}
                subHeading={item.subHeading}
              />
            ))}
          </CardWrapper>
        </ContentWrapper>
      )}
    </Wrapper>
  );
};
